'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _logger = require('../utils/logger');

var _logger2 = _interopRequireDefault(_logger);

var _userReducer = require('./userReducer');

var _userReducer2 = _interopRequireDefault(_userReducer);

var _userConstants = require('./userConstants');

var _currentUserConstants = require('./currentUserConstants');

var _selectionConstants = require('../../common/elements/selectionConstants');

var _elementConstants = require('../../common/elements/elementConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Constants


// Utils
var initialState = Immutable.Map();

// Reducers
// Lib


var addTrackedUsers = function addTrackedUsers(state, action) {
    return state.withMutations(function (mutableState) {
        return action.userIds.forEach(function (userId) {
            return mutableState.setIn([userId, '_id'], userId);
        });
    });
};

var loadUsers = function loadUsers(state, action) {
    return state.mergeDeep(action.users);
};

var loadActiveUsers = function loadActiveUsers(state, action) {
    return state.mergeDeep(action.users);
};

/**
 * Delegates the handling of the action to the user.
 * If the user does not exist then add its entry to the state.
 */
var delegateToUser = function delegateToUser(state, action) {
    if (!(action.user && action.user._id) && !action.userId) {
        _logger2.default.warn('User action does not contain a user ID', action);
        return state;
    }

    var userId = action.userId || action.user._id;

    // If we don't have the user then we cannot update it, we must set it
    return state.get(userId) ? state.update(userId, function (userEntry) {
        return (0, _userReducer2.default)(userEntry, action);
    }) : state.set(userId, (0, _userReducer2.default)(undefined, action));
};

var userActivityLoad = function userActivityLoad(state, action) {
    return state.withMutations(function (mutableState) {
        loadActiveUsers(mutableState, action);
        action.disconnectedUserIds.forEach(function (disconnectedUserId) {
            return mutableState.update(disconnectedUserId, function (userState) {
                return (0, _userReducer2.default)(userState, action);
            });
        });
    });
};

var delegateRemoteActionToUser = function delegateRemoteActionToUser(state, action) {
    return action.remote ? delegateToUser(state, action) : state;
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _userConstants.USER_ACTIVITY_LOAD:
            return userActivityLoad(state, action);
        case _userConstants.USERS_LOAD:
            return loadUsers(state, action);
        case _userConstants.USER_REFRESH:
        case _userConstants.USER_UPDATE:
        case _currentUserConstants.CURRENT_USER_SET:
        case _userConstants.USER_NAVIGATE:
            return delegateToUser(state, action);
        case _elementConstants.ELEMENT_MOVE_MULTI:
        case _elementConstants.ELEMENT_UPDATE:
        case _selectionConstants.ELEMENTS_SELECTED:
        case _selectionConstants.ELEMENTS_DESELECTED:
        case _userConstants.USER_CONNECT:
        case _userConstants.USER_DISCONNECT:
            return delegateRemoteActionToUser(state, action);
        case _userConstants.TRACK_USERS:
            return addTrackedUsers(state, action);
        case _elementConstants.ELEMENT_SHARE:
            return addTrackedUsers(state, { userIds: [action.userId] });
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/user/usersReducer.js
// module id = 2113
// module chunks = 0